import { rootStore } from "@/mobx/store";
import { observer } from "mobx-react";
import React, { useContext, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";

import Button from "@/components/button";
import { Page_settings } from "@/config/page_settings";
import colors from "@/design/colors";


import RowHeaderTable from "@/components/table/RowHeaderTable";
import TextField from "@/components/text_field";
import { deviceWidth } from "@/design/defaultTheme";
import { useWindowSize } from "@/hooks/useWindowSize";

/* **********************************
 * TYPES
 * 타입 정의
 ********************************** */
interface CatForm {
  id: string;
  storeId: number;
}

const CatCreate = observer(({goToListMode}: {goToListMode: () => void}) => {
  /* **********************************
   * GLOBAL STATE
   * 전역 상태 및 전역 변수
   ********************************** */
  const context: any = useContext(Page_settings);
  const token = rootStore.getMe?.accessToken;
  const { width } = useWindowSize();
  const isMobile = width < deviceWidth.mobile;
  const navigate = useNavigate();
  const { id } = useParams();
  

  /* **********************************
   * LOCAL STATE
   * 컴포넌트 내부에서 사용하는 상태
   ********************************** */

  /* **********************************
   * USEHOOK
   ********************************** */

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
  } = useForm<CatForm>({
    mode: "onChange",
    defaultValues: {
      id: "",
      storeId: 0,
    },
  });
  /* **********************************
   * Handler
   * 이벤트 핸들러
   ********************************** */
  const onSubmit = (data: CatForm) => {

    //console.table(data);
    //등록요청
    context.post(
      `/office/insertCatInfo`,
      {
        id: data.id,
        storeId: data.storeId
      },
      (response) => {
        console.log(response);
        if(response.RESULT_CODE === "0000"){  //
          goToListMode();
        }else{ //실패
          alert(response.RESULT_MSG);
        }
      }
    );
  };

  /* **********************************
   * EFFECTS
   * 컴포넌트 상태 변경 처리
   ********************************** */
  // 토큰 유무 확인
  useEffect(() => {
    if (!token) return;
  }, [token]);
  

  useEffect(() => {
    setValue('storeId', parseInt(id ?? "0"));
  }, [id]);
  
  
  /* **********************************
   * Table
   * 테이블 데이터
   ********************************** */
  const tableData = [
    {
      label: "CAT ID",
      value: (
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <Controller
            name="id"
            control={control}
            rules={{
              required: "CAT ID를 입력해주세요",
              maxLength: {
                value: 10,
                message: "최대 10자까지 입력 가능합니다",
              },
            }}
            render={({ field }) => (
              <TextField
                {...field}
                value={field.value || ""}
                placeholder="CAT ID"
                size="small"
                height="32px"
                padding="0 10px"
              />
            )}
          />
          <span style={{ fontSize: 12, color: colors.gray400 }}>
            숫자 10자
          </span>
          {errors.id && (
            <span style={{ color: colors.warning, fontSize: 12 }}>
              {errors.id.message}
            </span>
          )}
        </div>
      ),
      required: true,
    },
    {
      label: "타입",
      value: (
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <span>OFFLINE</span>
        </div>
      ),
    },
  ];

  

  /* **********************************
   * Element
   ********************************** */

  return (
    // 🔧 이 부분 form으로 감싸기
    <form onSubmit={handleSubmit(onSubmit)}>
      <Container>
        <section
          style={{
            marginBottom: "10px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              text="취소"
              size="small"
              width="60px"
              height="32px"
              buttonColor={colors.gray400}
              textColor={colors.gray50}
              customFontSize={isMobile ? "11px" : "13px"}
              style={{ padding: "0 10px" }}
              onClick={() => {
                goToListMode();
              }}
            />
            <Button
              text="저장"
              size="small"
              width="60px"
              height="32px"
              buttonColor={colors.blue600}
              textColor={colors.white}
              customFontSize={isMobile ? "11px" : "13px"}
              style={{ padding: "0 10px" }}
              type="submit"
              disabled={!isValid}
              onClick={() => {
                //insertPlatformInfo();
              }}
            />
          </div>
        </section>
        <section>
          <RowHeaderTable data={tableData} highlightRows={[]} />
        </section>
      </Container>
    </form>
  );
});

/* **********************************
 * Style
 * 스타일 처리
 ********************************** */
const Container = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 10px; 
`;

export default CatCreate;
